import { PagedSearch } from 'src/app/shared/model';

export class CommitteeMemberSearchDto extends PagedSearch {
  Active: boolean;
  IncludeInactive: boolean;
  ProfileIds: number[];
  RelProfileIds: number[];
  CommitteeIds: number[];
  MemberSince: Date;
  DateInactive: Date;
  CommitteeMemberIds: number[];
  ExcludeCommitteeMemberIds: number[];
}
